module.exports = __webpack_public_path__ + "static/media/portafolios2.7e79a5fe.jpg";